'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CountUp = require('./CountUp');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CountUp).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-countup/lib/index.js
 ** module id = 187
 ** module chunks = 1
 **/